'use strict';

/* ── MODE ── */
var Mode = {
  init: function(){
    var saved;
    try{ saved = localStorage.getItem('lv-mode'); }catch(e){}
    if(saved) document.documentElement.setAttribute('data-mode', saved);
  },
  toggle: function(){
    var cur = document.documentElement.getAttribute('data-mode');
    var next = cur === 'light' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-mode', next);
    try{ localStorage.setItem('lv-mode', next); }catch(e){}
  }
};
Mode.init();

/* ── NAV ── */
var Nav = {
  open: function(){
    document.getElementById('site-nav').classList.add('open');
    document.getElementById('nav-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  close: function(){
    document.getElementById('site-nav').classList.remove('open');
    document.getElementById('nav-overlay').classList.remove('open');
    document.body.style.overflow = '';
  },
  toggle: function(){
    document.getElementById('site-nav').classList.contains('open') ? Nav.close() : Nav.open();
  }
};

/* ── CART ── */
var Cart = {
  open: function(){
    document.getElementById('cart-panel').classList.add('open');
    document.getElementById('cart-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  },

  close: function(){
    document.getElementById('cart-panel').classList.remove('open');
    document.getElementById('cart-overlay').classList.remove('open');
    document.body.style.overflow = '';
  },

  money: function(cents){
    return '$' + (cents / 100).toFixed(2);
  },

  refresh: function(){
    return fetch('/cart.js')
      .then(function(r){
        return r.json();
      })
      .then(function(cart){

        // Update counters
        var cnt = document.getElementById('cart-count');
        if(cnt){
          cnt.textContent = cart.item_count;
          cnt.hidden = cart.item_count === 0;
        }

        var dcnt = document.getElementById('drawer-count');
        if(dcnt){
          dcnt.textContent = cart.item_count;
        }

        // Rebuild drawer body
        var body = document.getElementById('cart-panel-body');

        if(body){

          if(cart.item_count === 0){

            body.innerHTML =
              '<p class="cart-empty">Nothing here yet.</p>';

          } else {

            body.innerHTML = cart.items.map(function(item, index){

              var variant =
                item.variant_title &&
                item.variant_title !== 'Default Title'
                  ? '<p class="cart-line-variant">' + item.variant_title + '</p>'
                  : '';

              var image =
                item.image
                  ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy">'
                  : '';

              return `
                <div class="cart-line">
                  <a href="${item.url}" class="cart-line-img">
                    ${image}
                  </a>

                  <div class="cart-line-info">
                    <p class="cart-line-name">${item.product_title}</p>
                    ${variant}
                    <p class="cart-line-price">${Cart.money(item.final_price)}</p>
                  </div>

                  <a href="/cart/change?line=${index + 1}&quantity=0"
                     class="cart-line-remove"
                     aria-label="Remove">
                     ✕
                  </a>
                </div>
              `;

            }).join('');
          }
        }

        // Rebuild footer
        var foot = document.getElementById('cart-panel-foot');

        if(cart.item_count === 0){

          if(foot){
            foot.remove();
          }

        } else {

          var footerHtml = `
            <div id="cart-panel-foot">
              <div class="cart-subtotal">
                <span>Total</span>
                <span>${Cart.money(cart.total_price)}</span>
              </div>

              <a href="/checkout" class="btn-block">
                Checkout
              </a>

              <a href="/cart" class="btn-block btn-ghost">
                View Bag
              </a>
            </div>
          `;

          if(foot){

            foot.outerHTML = footerHtml;

          } else {

            document
              .getElementById('cart-panel')
              .insertAdjacentHTML('beforeend', footerHtml);
          }
        }
      });
  }
};

/* ── TOAST ── */
function toast(msg){
  var t = document.getElementById('toast');
  if(!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function(){ t.classList.remove('show'); }, 2200);
}

/* ── AJAX ADD TO CART ── */
document.addEventListener('submit', function(e){
  if(!e.target.matches('form[action="/cart/add"]')) return;
  e.preventDefault();
  var form = e.target;
  var btn = form.querySelector('[type=submit]');
  var orig = btn ? btn.textContent : '';
  if(btn){ btn.disabled = true; btn.textContent = '—'; }
  fetch('/cart/add.js',{ method:'POST', body: new FormData(form) })
    .then(function(r){ return r.json(); })
    .then(function(){
  return Cart.refresh();
})
.then(function(){
  Cart.open();
  toast('Added');

  if(btn){
    btn.disabled = false;
    btn.textContent = orig;
  }
})
    .catch(function(){
      if(btn){ btn.disabled = false; btn.textContent = orig; }
      form.submit();
    });
});

/* ── VARIANT BUTTONS ── */
document.querySelectorAll('.variant-opts').forEach(function(wrap){
  wrap.querySelectorAll('.variant-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      wrap.querySelectorAll('.variant-btn').forEach(function(b){ b.classList.remove('on'); });
      this.classList.add('on');
      var sel = document.querySelector('select[name=id]');
      if(sel && this.dataset.vid) sel.value = this.dataset.vid;
    });
  });
});

/* ── PRODUCT GALLERY ── */
document.querySelectorAll('.product-thumb').forEach(function(th){
  th.addEventListener('click', function(){
    var src = this.dataset.src;
    var main = document.querySelector('.product-main-img');
    if(main && src) main.src = src;
    document.querySelectorAll('.product-thumb').forEach(function(t){ t.classList.remove('on'); });
    this.classList.add('on');
  });
});

/* ── ACCORDION ── */
document.querySelectorAll('.detail-toggle').forEach(function(btn){
  btn.addEventListener('click', function(){
    var body = this.nextElementSibling;
    var open = this.classList.contains('open');
    this.classList.toggle('open', !open);
    body.classList.toggle('open', !open);
  });
});

/* ── HERO SLIDESHOW ── */
(function(){
  var slides = document.querySelectorAll('.hero-slide');
  var dots   = document.querySelectorAll('.hero-dot');
  if(!slides.length) return;
  var cur = 0, timer;
  function go(n){
    slides[cur].classList.remove('on');
    dots[cur] && dots[cur].classList.remove('on');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('on');
    dots[cur] && dots[cur].classList.add('on');
  }
  function start(){ timer = setInterval(function(){ go(cur+1); }, 5000); }
  go(0); start();
  dots.forEach(function(d,i){ d.addEventListener('click',function(){ go(i); clearInterval(timer); start(); }); });
  var h = document.querySelector('.hero');
  if(h){
    var tx = 0;
    h.addEventListener('touchstart',function(e){ tx = e.touches[0].clientX; },{passive:true});
    h.addEventListener('touchend',function(e){
      var dx = e.changedTouches[0].clientX - tx;
      if(Math.abs(dx)>44){ go(cur+(dx<0?1:-1)); clearInterval(timer); start(); }
    },{passive:true});
  }
})();

/* ── SCROLL REVEAL ── */
if('IntersectionObserver' in window){
  var ro = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); ro.unobserve(e.target); } });
  },{threshold:.08});
  document.querySelectorAll('.reveal').forEach(function(el){ ro.observe(el); });
} else {
  document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('on'); });
}

/* ── CART PAGE QTY ── */
document.querySelectorAll('.qty-input').forEach(function(inp){
  inp.addEventListener('change', function(){
    var form = document.getElementById('cart-form');
    if(form) form.submit();
  });
});

/* add toast div if missing */
if(!document.getElementById('toast')){
  var t = document.createElement('div');
  t.id = 'toast';
  document.body.appendChild(t);
}
